import { render, staticRenderFns } from "./Motivos_de_traslado.vue?vue&type=template&id=25cf1491&lang=pug&"
import script from "./Motivos_de_traslado.vue?vue&type=script&lang=js&"
export * from "./Motivos_de_traslado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports